/**
 * Experiment definition registry.
 *
 * `defineExperiment` declares an AB test with its PostHog flag key and durability tier.
 *
 * The durability tier controls how the assignment is persisted and restored:
 * - `"none"`:  live PostHog evaluation only, no persistence.
 * - `"flow"`:  stored in the Zustand signup-flow store for the current session.
 * - `"user"`:  written to DB table `ab_test_assignment` and restored on AC return so original variant persists.
 */

export type Durability = "none" | "flow" | "user";

export interface ExperimentDefinition {
  /** PostHog feature-flag key. */
  key: string;
  /** How the assignment is persisted (see above). */
  durability: Durability;
  /** Flow form names where the experiment is force-disabled. */
  excludeForms?: ReadonlySet<string>;
}

/**
 * Declares an experiment definition. The returned object is a plain config
 * that can be passed to `useFlagVariant()` or referenced in server-side code.
 */
export function defineExperiment(
  config: ExperimentDefinition,
): ExperimentDefinition {
  return config;
}
